<template>
  <div class="zadi-session-add-volunteers">
    <volunteers-selector v-can="permissions.edit" is-selected-ids full-entity :data-source-api="getAudience"
      :group-options="audienceGroups" btn-label="إضافة المتطوعين" @onSubmit="onConfirmAdd">
      <template #actions>
        <span v-if="session && session.availableSeats != null">
          المقاعد المتبقية: {{ session.availableSeats }}
        </span>
      </template>
    </volunteers-selector>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import VolunteersSelector from "@/app/volunteer/components/VolunteersSelector.vue";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");

export default {
  name: "ZadiSessionAddVolunteers",
  components: {
    VolunteersSelector,
  },
  data() {
    return {
      permissions: {
        edit: "training_courses_management",
      },
      session: null,
      audienceGroups: [],
      isAudienceGroupsLoaded: false,
    };
  },
  methods: {
    async getSession() {
      this.session = await zadiSessionsRepo.getZadiSession(this.$route.params.id);
    },
    // scope=all لأن أي متطوع قابل للإضافة، ومن أُلغي تسجيله يُحسب assigned فيغيب عن unassigned
    async getAudience(query) {
      const response = await zadiSessionsRepo.fetchZadiSessionAudience(
        this.$route.params.id,
        `${query}&scope=all`
      );
      // نثبّت قائمة المجموعات على أول جلب، وإلا اختفت بقية الخيارات عند الفلترة بمجموعة
      if (!this.isAudienceGroupsLoaded) {
        this.audienceGroups = response.groups || [];
        this.isAudienceGroupsLoaded = true;
      }
      return response.volunteers || { data: [], total: 0 };
    },
    onConfirmAdd(payload) {
      const volunteers = payload.selectedVolunteer;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "تأكيد إضافة المتطوعين",
        text: `عدد المتطوعين المحددين: ${volunteers.length}. سيُضافون كمسجّلين في الجلسة، ويُرفض الطلب كاملاً إن لم تكفِ المقاعد المتبقية.`,
        acceptText: "إضافة",
        cancelText: "إلغاء",
        accept: () => this.addVolunteers(volunteers),
      });
    },
    async addVolunteers(volunteers) {
      let response;
      try {
        response = await zadiSessionsRepo.addZadiSessionVolunteers(
          this.$route.params.id,
          volunteers.map((volunteer) => volunteer.id)
        );
      } catch {
        // الـ interceptor يعرض رسالة الخطأ، ونبقى في الصفحة مع التحديد ليقلّصه المستخدم
        return;
      }
      this.notifyAddResult(response.data);
      this.$router.push({ path: `/volunteers/zadi-sessions/${this.$route.params.id}/check-ins` });
    },
    // المتخطّى مسجّل مسبقاً أو له نتيجة حضور، فهو معلومة لا خطأ
    notifyAddResult(result) {
      if (!result || result.addedCount == null) return;
      const skipped = result.skippedCount
        ? `، الموجودون في السجل مسبقاً: ${result.skippedCount}`
        : "";
      this.$vs.notify({
        title: "إضافة المتطوعين",
        color: result.addedCount ? "success" : "warning",
        text: `عدد المضافين: ${result.addedCount}${skipped}`,
      });
    },
  },
  created() {
    this.getSession();
  },
};
</script>
